var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LiveAccountDetails',{attrs:{"page-label":"Trading Account Details"}})
}
var staticRenderFns = []

export { render, staticRenderFns }